import type { SettingValueMap } from 'portlet/models';

import type { QueryReplacer } from '.';

export const ConditionFieldReplacer: QueryReplacer = {
    regex: /\{conditionField\}/,
    replace: (statement, _metadata, _filterValues, regexMatches, settings) => {
        const value = getDatabricksConditionFieldValue(settings);

        return regexMatches.reduce((pre, cur) => pre.replace(cur.exact, value), statement);
    },
};

export function getDatabricksConditionFieldValue(settings: Partial<SettingValueMap>): string {
    return settings.DATABRICKS_CONDITION && settings.DATABRICKS_CONDITION.field
        ? settings.DATABRICKS_CONDITION.field
        : '';
}
